import { alpha, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import "./EldDeviceParsedMessageErrorField.css";

interface Props {
  error?: string | null;
}

const useStyles = makeStyles<Theme>((theme) => ({
  error: {
    borderColor: theme.palette.error.dark,
    backgroundColor: alpha(theme.palette.error.light, 0.2),
  },
}));

export const EldDeviceParsedMessageErrorField = ({ error }: Props) => {
  const classes = useStyles();
  if (!error) {
    return null;
  }

  return (
    <div className={`parsed-message-error ${classes.error}`}>
      <p>{error}</p>
    </div>
  );
};
